import script from "./ValuesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ValuesSection.vue?vue&type=script&setup=true&lang=js"

import "./ValuesSection.vue?vue&type=style&index=0&id=b4047e12&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4047e12"]])

export default __exports__